import * as S from './StripeInput.styles'

function StripeInput({
  value,
  onChange,
  isInvalid,
  placeholder,
  label,
  name,
  testId,
  onBlur,
}) {
  return (
    <>
      {label && <S.Label>{label}</S.Label>}
      <S.Input
        key="stripe-input"
        id="stripe-input"
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        name={name}
        placeholder={placeholder}
        $invalid={isInvalid}
        data-testid={testId}
      />
    </>
  )
}

export default StripeInput
